import { FC } from 'react';
import { EmptyData } from '../../components';
import translations from './NoDataRow.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';

const { addTranslations, useTranslation } = i18nNsFactory('table-no-data-cell');
addTranslations(translations);

type NoDataRowProps = {
  colSpan: number;
  hideImage?: boolean;
};

export const NoDataRow: FC<NoDataRowProps> = ({ colSpan, hideImage }) => {
  const { t } = useTranslation();

  return (
    <tr>
      <td colSpan={colSpan}>
        <EmptyData hideImage={hideImage}>{t('emptyText.default')}</EmptyData>
      </td>
    </tr>
  );
};
